import React from "react";
import { actionLabel, roleLabel, roleClass } from "../roles";

function findPlayer(players, id) {
  return players.find((p) => p.id === id) || null;
}

// Колірне кодування ролі в журналі — воно вже є для карток гравців, тож
// дає миттєве візуальне сприйняття хто є хто, а не лише текст.
function NameWithRole({ player }) {
  if (!player) return <>—</>;
  return (
    <>
      {player.name}{" "}
      <span className={roleClass(player.role)}>({roleLabel(player.role)})</span>
    </>
  );
}

export default function ActionLog({ players, actions, onUndo, undoing, readOnly = false }) {
  const hasActions = actions.length > 0;

  return (
    <div className="action-log-wrap">
      {hasActions && !readOnly && (
        <div className="action-log-toolbar">
          <button
            type="button"
            className="btn btn-ghost btn-small"
            onClick={onUndo}
            disabled={undoing}
          >
            {undoing ? "Скасовуємо…" : "↩ Скасувати останній запис"}
          </button>
        </div>
      )}

      {!hasActions ? (
        <div className="empty-state empty-state-small">
          <p>Журнал порожній. Перша записана дія з'явиться тут.</p>
        </div>
      ) : (
        <ol className="action-log">
          {[...actions].reverse().map((a) => (
            <li key={a.id} className="action-log-row">
              <span className="action-log-meta">
                Раунд {a.round} · {a.phase === "night" ? "ніч" : "день"}
              </span>
              <span className="action-log-body">
                <strong>{actionLabel(a.type)}</strong>
                {a.actorId && (
                  <>
                    {" "}
                    · <NameWithRole player={findPlayer(players, a.actorId)} />
                  </>
                )}
                {a.targetId && (
                  <>
                    {" "}
                    → <NameWithRole player={findPlayer(players, a.targetId)} />
                  </>
                )}
                {a.note && <span className="action-log-note"> — {a.note}</span>}
              </span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
